var map = {
	"./01_TP84744235.webp": 971,
	"./02_TP14623786.webp": 9756,
	"./03_Critical_Thinking.webp": 4418,
	"./04_Strategic_Thinking.webp": 9180,
	"./05_The_Morning_Habits.webp": 1840
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6629;